
import Vue from 'vue';
import {timeCJ,setTimeHtml} from '../../../static/js/calendarPanle.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import AlertModule from 'vux/src/plugins/alert/module'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {fetch,promptMessage } from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
Vue.use(ConfirmPlugin)

export default {

data () {
return {
headerName:'',
paramsData:{},
dateTxt:'',
timeTxt:'',
mindateTXT:'',
sureDisable:false,
orderno:true,
}
},
directives: {
TransferDom
},
components: {
XHeader,XButton,Cell,Group,Datetime,XDialog, Checklist,Flexbox, FlexboxItem,Confirm,ConfirmPlugin, AlertModule,dateFormat
},
methods:{
sureClick(){
let _this = this;
if(this.dateTxt !='' && this.timeTxt !=''){
this.sureDisable = true;
if(this.paramsData.orderStatus == '未预约'){
var sureparam = new URLSearchParams();
sureparam.append('bsuperPayStatus',this.paramsData.bsuperPayStatus);
sureparam.append('bsuperOrderID',this.paramsData.bsuperOrderID);
sureparam.append('bsuperOrderDiagCode',this.paramsData.bsuperOrderDiagCode);
sureparam.append('personInfoId',this.personInfoId);
sureparam.append('orderClass',this.paramsData.orderClass);
sureparam.append('orderName',this.paramsData.orderName);
sureparam.append('orderDate',this.dateTxt);
sureparam.append('timeStepId',this.timeStepId);
sureparam.append('execDeptId',this.paramsData.execDeptId);
sureparam.append('area',this.paramsData.area);
sureparam.append('doctorId',null);
sureparam.append('doctorName',null);

fetch('post',urlConfig.reservationSure,sureparam).then(response => {

promptMessage('提示','预约成功！',function(){
_this.$router.push({path:'/reservationIndex?openid='+_this.$route.query.openid,query:{tabindex:1,personInfoId:_this.personInfoId,type:'jc'}});
});

}).catch(error => {
this.sureDisable = false;
})
}else {
var WYYsureparam = new URLSearchParams();
WYYsureparam.append('bsuperPayStatus',this.paramsData.bsuperPayStatus);
WYYsureparam.append('bsuperOrderID',this.paramsData.bsuperOrderID);
WYYsureparam.append('bsuperOrderDiagCode',this.paramsData.bsuperOrderDiagCode);
WYYsureparam.append('personInfoId',this.personInfoId);
WYYsureparam.append('oldOrderId',this.paramsData.orderId);
WYYsureparam.append('oldShiftTime',this.paramsData.shiftTime);
WYYsureparam.append('oldOrderDate',this.paramsData.orderDate);
WYYsureparam.append('orderClass',this.paramsData.orderClass);
WYYsureparam.append('orderName',this.paramsData.orderName);
WYYsureparam.append('orderDate',this.dateTxt);
WYYsureparam.append('timeStepId',this.timeStepId);
WYYsureparam.append('reqDeptId',this.paramsData.execDeptId);
WYYsureparam.append('area',this.paramsData.area);

fetch('post',urlConfig.reservationEdit,WYYsureparam).then(response => {

promptMessage('提示','修改成功！',function(){
_this.$router.push({path:'/reservationIndex?openid='+_this.$route.query.openid,query:{tabindex:1,personInfoId:_this.personInfoId,type:'jc'}});
});

}).catch(error => {
this.sureDisable = false;
})

}

}else if(this.dateTxt ==''){
promptMessage('提示','请选择预约日期！');
}else if(this.timeTxt ==''){
promptMessage('提示','请选择预约时间段！');
}

},//确认提交
getdateMthod(){
let _this = this;
return function(){
var timeparams = new URLSearchParams();
timeparams.append('orderClass',_this.paramsData.orderClass)
timeparams.append('area',_this.paramsData.area)
timeparams.append('bsuperOrderDiagCode',_this.paramsData.bsuperOrderDiagCode)
timeparams.append('orderDate',_this.dateTxt)
timeparams.append('schedulingDId',_this.paramsData.schedulingDId);
_this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.reservationDatetimes,timeparams).then(response => {
let timesArry = [];
for(let i=0;i<response.length;i++){
timesArry.push({key:response[i].scheTimeId,value:response[i].canOrderNum})
}
setTimeHtml(timesArry,'timeTxt',_this);
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}

},   //获取时间段
dateChange(){
if(this.dateTxt == ''){
this.dateTxt = dateFormat(new Date(), 'YYYY-MM-DD')
}
this.getdateMthod()();
$('.mask-time,.time-area').show();

}, //获取时间段
},
mounted(){

let _this = this;
this.paramsData =  JSON.parse(localStorage.getItem('reservationData'));
this.personInfoId = this.$route.query.personInfoId;
var orderStatus = this.paramsData.orderStatus;
if(this.paramsData.bsuperOrderDiagCode){

}else {
this.paramsData.bsuperOrderDiagCode = null;
}
if(orderStatus == 1){
this.dateTxt = this.paramsData.orderDate;
this.timeTxt = this.paramsData.shiftTime;
this.headerName = '修改预约';
}else {
this.headerName = '确认预约';
}
timeCJ('timeTxt','dateTxt',this,this.getdateMthod());
if(this.paramsData.bsuperOrderID == null){
this.orderno = false;

}else {
this.orderno = true;
}
$('.mask-time').height($(window).height());
$('.btn-choose-time').click(function() {
if (_this.timeTxt =='') {
promptMessage('提示','请选择就诊时间段!');
}else{  //确认选择按钮
_this.timeStepId = $('.time-table.choosed').attr('keyid')
$('.mask-time,.time-area').css("display", "none");
}
});



}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationDetails.vue